import {FETCH_ALL_TIMELINE_HOME
      } from '../actions/timelineAction';
const INITIAL_STATE = { 
        all_time_home:[]
      };

export default function(state = INITIAL_STATE,action){

switch (action.type) {
case FETCH_ALL_TIMELINE_HOME:
    
    return {
             all_time_home : (action.payload.data ? action.payload.data:[])
        } 
    default:
    return state;

    }

}


// WEBPACK FOOTER //
// ./src/reducers/reducer_timeline.js